import { z } from 'zod';

export const HOLDER_TYPE = {
  FULFILLMENT: 'fulfillment',
  INVENTORY_HOLD: 'inventory_hold',
} as const;

export type HolderType = (typeof HOLDER_TYPE)[keyof typeof HOLDER_TYPE];

const FulfillmentReservationSchema = z.object({
  holder_type: z.literal(HOLDER_TYPE.FULFILLMENT),
  holder_id: z.string(),
  holder_number: z.string(),
  holder_status: z.string(),
  reserved_quantity: z.number(),
  source_type: z.string(),
  order_name: z.string().nullable().optional(),
  order_status: z.string().nullable().optional(),
});

const InventoryHoldReservationSchema = z.object({
  holder_type: z.literal(HOLDER_TYPE.INVENTORY_HOLD),
  holder_id: z.string(),
  holder_number: z.string(),
  holder_status: z.string(),
  reserved_quantity: z.number(),
  reason: z.string().nullable().optional(),
  note: z.string().nullable().optional(),
  held_by_name: z.string().nullable().optional(),
});

export const BlockingReservationSchema = z.discriminatedUnion('holder_type', [
  FulfillmentReservationSchema,
  InventoryHoldReservationSchema,
]);

export type BlockingReservation = z.infer<typeof BlockingReservationSchema>;
export type FulfillmentSourceType = z.infer<typeof FulfillmentReservationSchema>['source_type'];

export const InventoryConflictSchema = z.object({
  inventory_id: z.string(),
  product_name: z.string(),
  product_sku: z.string(),
  total_quantity: z.number(),
  allocated_quantity: z.number(),
  held_quantity: z.number(),
  adjustment_quantity: z.number(),
  max_adjustable: z.number(),
  shortage: z.number(),
  blocking_reservations: z.array(BlockingReservationSchema),
});

export type InventoryConflict = z.infer<typeof InventoryConflictSchema>;

export const PreviewInventoryChangesResponseSchema = z.object({
  has_conflicts: z.boolean(),
  conflicts: z.array(InventoryConflictSchema),
});

export type PreviewInventoryChangesResponse = z.infer<typeof PreviewInventoryChangesResponseSchema>;
